<div class="dialog-viewer">
    <h2 mat-dialog-title>Add Members to Iteration</h2>
    <form [formGroup]="form">
        <mat-dialog-content>
            <div class="container-fluid">
                <div class="row mb-4">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Iteration</mat-label>
                            <mat-select [(ngModel)]="selectedIterationId" 
                                [formControl]="form.get('iterationId')" formControlName="iterationId">
                                <mat-option *ngFor="let iteration of iterations" [value]="iteration.id">
                                    {{iteration.year}} ({{iteration.startDate | date:'MM/dd/yyyy'}} - {{iteration.endDate | date:'MM/dd/yyyy'}})
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <h3 class="mat-h3 mb-3">Select Members to Add</h3>
                        <div class="member-selection-container" style="max-height: 400px; overflow-y: auto;">
                            <mat-selection-list [(ngModel)]="selectedMembers" [ngModelOptions]="{standalone: true}">
                                <mat-list-option *ngFor="let member of availableMembers" [value]="member.id" 
                                    [selected]="isMemberSelected(member.id)">
                                    <div class="d-flex justify-content-between align-items-center w-100">
                                        <div>
                                            <strong>{{member.firstName}} {{member.lastName}}</strong>
                                            <span *ngIf="member.email" class="text-muted ml-2">{{member.email}}</span>
                                        </div>
                                    </div>
                                </mat-list-option>
                            </mat-selection-list>
                            
                            <div *ngIf="availableMembers.length === 0" class="text-center py-5">
                                <p [ngClass]="{'text-muted': !isDarkMode, 'text-muted-dark-mode': isDarkMode}">No members available to add to this iteration.</p>
                            </div>
                        </div>
                        <p [ngClass]="{'text-muted': !isDarkMode, 'text-muted-dark-mode': isDarkMode}" class="small mt-2">
                            Selected: {{selectedMembers.length}} member(s)
                        </p>
                        <mat-error *ngIf="errorMessage" [innerHTML]="errorMessage"></mat-error>
                    </div>
                </div>
            </div>

            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="text-center">
                <button mat-raised-button type="button" 
                    [disabled]="isLoading || !selectedIterationId || selectedMembers.length === 0"
                    (click)="submit()">
                    Add Members
                </button>
                <button mat-raised-button (click)="dialogRef.close('cancel')" class="warning" [disabled]="isLoading">
                    Cancel
                </button>
            </div>
        </mat-dialog-actions>
    </form>
</div>

